import { Button, Card, Checkbox, Tooltip } from "antd";
import { useDispatch } from "react-redux";
import {
  deleteAddresse,
  updateSaveAddresse,
} from "../AddressesSlice/Addresses.slice";
import CustomForm from "../../../components/CustomForm";
import React, { useEffect, useRef, useState } from "react";
import { UserOutlined } from "@ant-design/icons";
import { onlyRoleMapping, userHasLevel } from "../../../../engine/AuthRoute";
import { roles } from "../../../../utils/constants";
import routes from "../../../../engine/routes";
import { inputsAddresseItem } from "./AddresseItemInputs";
import { addresseItemMapsInputs } from "./AddresseItemMapsInputs";
import { typeAddress } from "./AddresseHelpers";
import { truncateDecimal } from "../../../../utils/helpersFunction";
import { http } from "../../../../engine/api/http";
import { confirmDeleteAddress } from "../../../components/Modals/modals";
import { Link } from "react-router-dom";

export const AddresseItem = ({
  address,
  defaultId = null,
  changeDefault,
  isChecked,
  institution,
  type,
  principal,
  isNew = false,
}) => {
  const { _id } = address;

  const formRef = useRef(null);

  const dispatch = useDispatch();
  const [isEdit, setIsEdit] = useState(false);
  const [isUsed, setIsUsed] = useState(false);

  useEffect(() => {
    if (type === typeAddress.postal && _id) {
      http
        .get(`/addresses/${_id}/deleteStatus`)
        .then(res => {
          const { prestations = [], bills = [] } = res.data;
          setIsUsed(prestations.length > 0 || bills.length > 0);
        })
        .catch(() => {});
    }
  }, [_id, type]);

  const deleteItem = async () => {
    const res = await http.get(`/addresses/${_id}/deleteStatus`);

    confirmDeleteAddress({
      onOk: () => {
        dispatch(deleteAddresse(address));
        if (isChecked) {
          changeDefault(null);
        }
      },
      props: res.data,
    });
  };

  const toggleAvailableForBilling = checked => {
    dispatch(updateSaveAddresse({ _id, availableForBilling: checked }));
  };

  const {
    complement,
    number,
    person,
    external,
    street,
    description,
    principal: principalAdress,
    institution: institutionAdress,
    location,
    maps,
    city,
    canton,
    beneficiary,
    zip,
    country,
    sharedToInstitutions = [],
  } = address;

  const addressPrincipalToInstitution = () => {
    if (
      institution !== null &&
      address.principal !== null &&
      address.institution === null
    ) {
      return true;
    } else {
      return false;
    }
  };

  /** ID institution propriétaire de l'adresse (string), ou null (ex. mandant sans institution sur l'adresse) */
  const ownerInstitutionId = (() => {
    const inst = address?.institution;
    if (inst == null) return null;
    const raw =
      typeof inst === "object" && inst._id != null ? inst._id : inst;
    if (raw == null || raw === "") return null;
    return String(raw);
  })();

  const viewerInstitutionId =
    institution?._id != null ? String(institution._id) : null;

  /** Vue « emprunteuse » : l'adresse appartient à une autre institution (partage). Comparaison d'id normalisée (ObjectId vs string). */
  const isAdressShared = () => {
    if (address.principal != null) {
      return false;
    }
    if (!ownerInstitutionId || !viewerInstitutionId) {
      return false;
    }
    return ownerInstitutionId !== viewerInstitutionId;
  };

  const lockPostalIdentityOnly =
    isUsed &&
    type === typeAddress.postal &&
    !isAdressShared() &&
    !addressPrincipalToInstitution();

  const blockModifierDueToUsedPostal =
    isUsed &&
    type === typeAddress.postal &&
    (isAdressShared() || addressPrincipalToInstitution());

  const handleSubmit = data => {
    // data.address.external = data.address.external === "on";

    let payload = {};

    if (type === typeAddress.postal) {
      if (lockPostalIdentityOnly) {
        payload = {
          _id: address._id,
          sharedToInstitutions: data?.sharedToInstitutions || [],
        };
      } else {
        payload = {
          ...data.address,
          sharedToInstitutions: data?.sharedToInstitutions || [],
          description: data.description,
          _id: address._id,
        };
      }
    }

    if (type === typeAddress.maps) {
      const allData = formRef.current.getFieldsValue(true);

      payload = {
        _id: address._id,
        ...data,
      };

      if (
        allData.maps !== undefined &&
        allData.lng_maps !== undefined &&
        allData.canton_maps !== undefined &&
        allData.lat_maps !== undefined
      ) {
        payload.longitude = truncateDecimal(allData?.lng_maps || 0, 5);
        payload.latitude = truncateDecimal(allData?.lat_maps || 0, 5);
        payload.canton = allData?.canton_maps || "";
      }
    }

    const update = dispatch(updateSaveAddresse(payload));
  };

  const changeEdition = () => {
    setIsEdit(!isEdit);
  };

  const renderAddress = () => {
    return (
      <span>
        <b>{beneficiary}</b>
        {person !== "" && (
          <>
            <br />
            <b>{person}</b>
          </>
        )}
        <br />

        <span>
          {street} {number}
          <br />
          {complement !== "" && (
            <>
              {complement}
              <br />
            </>
          )}
          {zip} {city}
          <br />
          {canton} {country}
        </span>
        {(external || sharedToInstitutions.length > 0) && (
          <>
            <br />
            <div
              style={{
                width: "300px",
                height: "1px",
                background: "#b2b1b1",
                marginTop: "10px",
                marginBottom: "10px",
              }}
            />
            {external && (
              <>
                <cite>*Institution externe, facture par courrier postal</cite>
              </>
            )}
            {sharedToInstitutions.length > 0 && (
              <>
                <br />
                <b>
                  Partagé avec {sharedToInstitutions.length} institution
                  {sharedToInstitutions.length > 1 ? "s" : ""}
                </b>
              </>
            )}
          </>
        )}
      </span>
    );
  };
  const renderMaps = () => {
    return (
      <span>
        <b>{maps}</b>
      </span>
    );
  };

  const userCanUpdate = userHasLevel(
    type === typeAddress.maps
      ? routes.institutions().locations
      : routes.institutions().addresses,
    "u",
  );

  const userCanChangeAddress = () => {
    if (isAdressShared()) {
      return true;
    }

    if (addressPrincipalToInstitution()) {
      return true;
    } else {
      return !userCanUpdate;
    }
  };

  const renderText = () => {
    return type === typeAddress.postal ? renderAddress() : renderMaps();
  };

  const modifierTooltip = (() => {
    if (blockModifierDueToUsedPostal && isAdressShared()) {
      return "Adresse utilisée : le partage n'est modifiable que depuis l'institution propriétaire.";
    }
    if (blockModifierDueToUsedPostal && addressPrincipalToInstitution()) {
      return "Adresse utilisée dans des prestations ou factures.";
    }
    if (isUsed && type === typeAddress.postal) {
      return "Adresse utilisée : seuls le partage et la disponibilité facturation sont modifiables.";
    }
    return undefined;
  })();

  return (
    <>
      <Card
        key={_id}
        title={<>{type === typeAddress.postal ? description : location}</>}
        extra={[
          addressPrincipalToInstitution() && principal === null ? (
            <b style={{ marginRight: 10 }}>Mandant {principalAdress.name}</b>
          ) : null,
          institutionAdress !== null &&
          String(institutionAdress?._id ?? "") !==
            String(institution?._id ?? "") ? (
            <Link
              to={routes.institutions(String(institutionAdress._id)).addresses.path}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                marginRight: 10,
                fontWeight: "bold",
                color: "var(--color-primary)",
                textDecoration: "underline",
              }}
            >
              Institution {institutionAdress?.name}
            </Link>
          ) : null,
          <Tooltip title={modifierTooltip}>
            <Button
              disabled={
                userCanChangeAddress() || blockModifierDueToUsedPostal
              }
              onClick={changeEdition}
              size={"small"}
              type={"primary"}
              style={{ marginRight: 10 }}
            >
              {isEdit ? "Annuler" : "Modifier"}
            </Button>
          </Tooltip>,
          <Button
            disabled={!isEdit && userCanChangeAddress()}
            onClick={deleteItem}
            size={"small"}
            type={"primary"}
          >
            Supprimer
          </Button>,
        ]}
      >
        {isEdit ? (
          <CustomForm
            key={`address-edit-${_id}`}
            refForm={formRef}
            disabled={!userCanUpdate}
            dataSource={
              type === typeAddress.postal
                ? inputsAddresseItem({
                    address,
                    description,
                    changeEdition,
                    sharedToInstitutions,
                    lockIdentityFields: lockPostalIdentityOnly,
                  })
                : addresseItemMapsInputs({
                    location,
                    maps,
                    changeEdition,
                  })
            }
            labelCol={24}
            wrapperCol={24}
            handleSubmit={handleSubmit}
          />
        ) : (
          renderText()
        )}
      </Card>
      <br />
      <label disabled={isChecked}>
        <Checkbox
          disabled={isChecked || !userCanUpdate}
          checked={isChecked}
          size={"large"}
          onChange={e => {
            changeDefault(address);
          }}
        />
        <span style={{ padding: 5 }}>Adresse par défaut</span>
      </label>
      {type === typeAddress.postal && (
        <Tooltip
          title={
            isAdressShared()
              ? "Réservé à l'institution propriétaire de l'adresse."
              : undefined
          }
        >
          <label style={{ marginLeft: 16 }}>
            <Checkbox
              disabled={!userCanUpdate || isAdressShared()}
              checked={address.availableForBilling !== false}
              size={"large"}
              onChange={e => {
                toggleAvailableForBilling(e.target.checked);
              }}
            />
            <span style={{ padding: 5 }}>
              Disponible pour la facturation
            </span>
          </label>
        </Tooltip>
      )}
    </>
  );
};
